import { ParametrosService } from './parametros.service';
import { AlterarSenhaModel } from '../../restrito/consumidor/consumidor-alterar-senha/alterar-senha.model';
import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { GenericHttpService, ConfiguracoesProjeto } from '../index';
import { DadosAlteracaoSenhaModel } from '../../restrito/consumidor/consumidor-alterar-senha/dados-alteracao-senha-model';

@Injectable()
export class RecuperacaoSenhaService {

  private _urlBase: string;
  private _urlBaseConta: string;
  private configuracao: ConfiguracoesProjeto;

  constructor(private readonly genericHttpService: GenericHttpService<Response>,
    private readonly parametrosService: ParametrosService) { }

  get urlBase() {
    this.configuracao = this.parametrosService.getConfiguracao();
    this._urlBase = this.configuracao.uri + 'recuperacao-senha';

    return this._urlBase;
  }

  get urlBaseConta() {
    this.configuracao = this.parametrosService.getConfiguracao();
    this._urlBaseConta = this.configuracao.uri + 'conta';

    return this._urlBaseConta;
  }

  public getEmailLinkRecuperacaoSenha(cpf: string): Observable<Response> {
    return this.genericHttpService.getById(this.urlBase + `/${cpf}`);
  }

  public postSalvarNovaSenha(cpf: string, guid: string, senha: string): Observable<Response> {

    let dadosAlteracaoSenha = new DadosAlteracaoSenhaModel();
    dadosAlteracaoSenha.cpf =  cpf;
    dadosAlteracaoSenha.senha = senha;
    dadosAlteracaoSenha.guid = guid;

    return this.genericHttpService.putAny(this.urlBase + '/definicao-nova-senha', dadosAlteracaoSenha);
  }

  public putAlterarSenhaCidadaLogado(alterarSenha: AlterarSenhaModel) {
    return this.genericHttpService.putAny(this.urlBaseConta + `/alteracao-senha-logado`, alterarSenha);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/service/recuperacao-senha.service.ts